module.exports = __webpack_public_path__ + "img/angry.1f6e925c.png";